<div class="admin-main-container-menu">
  @if (showPromotions) {
    <a class="button-admin-menu" id="admin-promotions" routerLink="/admin/promotions" routerLinkActive="router-active"> > {{'' | i18n: 'promotions'}}</a>
  }
  @if (showActionPeriods) {
    <a class="button-admin-menu" id="admin-actionPeriods" routerLink="/admin/action-periods" routerLinkActive="router-active"> > {{'' | i18n: 'action-periods'}}</a>
  }
  <a class="button-admin-menu" id="admin-warranty-config" routerLink="/admin/config" routerLinkActive="router-active"> > {{'' | i18n: 'warranty-config'}}</a>
  <a class="button-admin-menu" id="admin-calc-log" routerLink="/admin/calc-log" routerLinkActive="router-active"> > {{'' | i18n: 'calc-log'}}</a>
  <a class="button-admin-menu" id="admin-dealer-management" routerLink="/admin/dealers" routerLinkActive="router-active"> > {{'' | i18n: 'dealer-management'}}</a>
  <a class="button-admin-menu" id="admin-blacklist" routerLink="/admin/blacklist" routerLinkActive="router-active"> > {{'' | i18n: 'blacklist'}}</a>
  @if (showE4n) {
    <a class="button-admin-menu" id="admin-e4n" routerLink="/admin/e4n" routerLinkActive="router-active"> > {{'' | i18n: 'e4n-upload'}}</a>
  }
  <a class="button-admin-menu" id="admin-disclaimer" routerLink="/admin/disclaimer" routerLinkActive="router-active"> > {{'' | i18n: 'disclaimer-config'}}</a>
  <a class="button-admin-menu" id="admin-help" routerLink="/admin/help-config" routerLinkActive="router-active"> > {{'' | i18n: 'help-config'}}</a>
</div>
